import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { ExternalLink } from 'lucide-react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';
import { trackEvent } from 'helpers/analytics';

export const ContactLinkRenderer = ({ data, value, ...props }) => {
  const { colors } = useTheme();

  if (data?.options?.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={120}
        viewBox="0 0 400 120"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
        {...props}
      >
        <rect x="9" y="18" rx="4" ry="4" width="80" height="8" />
      </ContentLoader>
    );
  }

  if (!value) {
    return '';
  }

  return (
    <Box
      display="grid"
      height="100%"
      width="100%"
      sx={{
        '&:hover #link-icon': {
          opacity: 1,
        },
      }}
    >
      <Flex p="8px" alignItems="center" justifyContent="space-between" sx={{ gap: '8px' }}>
        <Text
          fontSize="14px"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Text>

        <Box
          onClick={() => {
            trackEvent('contacts:view_linkedin_profile', {
              collectionId: data.options.activeNetwork.id,
              page: data.options.page,
              contactId: data.id,
            });
          }}
          id="link-icon"
          as="a"
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            cursor: 'pointer',
            display: 'flex',
            bg: 'neutral.20',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'opacity 0.2s ease',
            opacity: 0,
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom: '0px',
            padding: '8px',
          }}
        >
          <Box as={ExternalLink} size="16px" />
        </Box>
      </Flex>
    </Box>
  );
};

ContactLinkRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object]),
  data: PropTypes.object,
};

ContactLinkRenderer.defaultProps = {
  value: '',
  data: {},
};
